import React, { useEffect, useRef } from "react";
import { type Href, Stack, useRouter, useUnstableGlobalHref } from "expo-router";
import { useAuth } from "@/elements/context/auth";

function AppProtectedLayout() {
  const { isReady, isAuthenticated, setRedirectTarget } = useAuth();
  const wasAuthenticatedRef = useRef(false);

  const router = useRouter();
  const redirectTarget = useUnstableGlobalHref();

  useEffect(() => {
    if (!isReady) return;

    if (isAuthenticated) {
      wasAuthenticatedRef.current = true;
      return;
    }

    if (wasAuthenticatedRef.current) {
      wasAuthenticatedRef.current = false;
      setRedirectTarget(null);
    } else {
      setRedirectTarget(redirectTarget as Href);
    }

    router.replace("/(auth)/sign-in-options");
  }, [isReady, isAuthenticated, setRedirectTarget, redirectTarget, router]);

  return <Stack screenOptions={{ headerShown: false }} />;
}

export default AppProtectedLayout;
